var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"logo-wrapper",attrs:{"text":"","plain":""},on:{"click":function($event){return _vm.goTo('home')}}},[_c(_vm.logoVariant,{tag:"component",attrs:{"height":_vm.height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }